// ============================================================
// FILE: src/components/Preloader.jsx  →  OPENING ANIMATION
// The first animation visitors see: the EVOLVE logo zooms in
// with glowing rings, then zooms out into the homepage.
// ============================================================

import { motion } from "framer-motion";

const letters = "EVOLVE".split("");

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#020617]"
      exit={{ scale: 1.35, opacity: 0, filter: "blur(8px)", transition: { duration: 0.4, ease: [0.76, 0, 0.24, 1] } }}
    >
      {/* Expanding glow rings behind logo */}
      {[0, 0.15].map((d, i) => (
        <motion.div
          key={i}
          className="absolute h-64 w-64 rounded-full border border-teal-500/30"
          initial={{ scale: 0.2, opacity: 0.8 }}
          animate={{ scale: 2.4, opacity: 0 }}
          transition={{ delay: 0.1 + d, duration: 0.9, ease: "easeOut" }}
        />
      ))}
      <motion.div
        className="absolute h-72 w-72 rounded-full bg-teal-500/10 blur-3xl"
        initial={{ scale: 0.3, opacity: 0 }}
        animate={{ scale: 1.4, opacity: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      />

      {/* Logo — direct zoom-in */}
      <motion.img
        src="/logo.png"
        alt="Evolve Trade & Logistics"
        className="relative h-28 w-auto object-contain drop-shadow-[0_0_40px_rgba(20,184,166,0.45)]"
        initial={{ scale: 0.15, opacity: 0, filter: "blur(14px)" }}
        animate={{ scale: [0.15, 1.14, 1], opacity: 1, filter: "blur(0px)" }}
        transition={{ duration: 0.7, times: [0, 0.72, 1], ease: [0.22, 1, 0.36, 1] }}
      />

      <div className="mt-6 flex overflow-hidden">
        {letters.map((l, i) => (
          <motion.span
            key={i}
            className="font-display text-3xl font-bold tracking-[0.4em] text-white"
            initial={{ y: "120%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.25 + i * 0.04, duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          >
            {l}
          </motion.span>
        ))}
      </div>
      <motion.p
        className="mt-3 text-[10px] font-semibold uppercase tracking-[0.5em] text-teal-400"
        initial={{ opacity: 0, letterSpacing: "0.9em" }}
        animate={{ opacity: 1, letterSpacing: "0.5em" }}
        transition={{ delay: 0.4, duration: 0.4 }}
      >
        Trade &amp; Logistics
      </motion.p>
      <motion.div
        className="mt-8 h-px w-48 origin-left bg-gradient-to-r from-teal-400 to-sky-400"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.3, duration: 0.5, ease: "easeInOut" }}
      />
    </motion.div>
  );
}
